import React from 'react';
import { GuestSiteTypographyOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride';
import { hed6ToSubHeadingOverride, label2ToParagraphOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride.constants';
import { Flex, Box, IconV2, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { useThingToDoCategoryUtils, useAspectRatioHeight } from './hooks';
import { CustomContainerWrapper, ThingToDoComponentProps, Thumbnail } from '.';
import { getDomainFromUrl } from './utils';

interface ThingToDoTileProps extends ThingToDoComponentProps {
  onClick?: () => void;
  FooterContent?: React.ReactNode;
}

export const ThingToDoTile: React.FC<ThingToDoTileProps> = ({ onClick, FooterContent, forceFullWidth = false, ...props }) => {
  const { getCategoryTranslation, getCategoryIcon, isGetYourGuideDomain } = useThingToDoCategoryUtils();
  const { elementRef: figureRef, calculatedHeight } = useAspectRatioHeight(1.6, 148);

  return (
    <CustomContainerWrapper
      designType="widget"
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
      forceFullWidth={forceFullWidth}
    >
      {props.image?.url && (
        <Flex
          ref={figureRef}
          as="figure"
          width="100%"
          overflow="hidden"
          height={pxToRem(calculatedHeight)}
          borderRadius={pxToRem(12)}
        >
          <picture style={{ width: '100%', overflow: 'hidden' }}>
            <source srcSet={props.image.url} />
            <Thumbnail
              src={props.image.url}
              alt={props.title}
              height={pxToRem(calculatedHeight)}
            />
          </picture>
        </Flex>
      )}
      <Flex
        flex="1"
        paddingY={pxToRem(16)}
        flexDirection="column"
        justifyContent="space-between"
        width="100%"
      >
        <Box>
          <Flex
            alignItems="center"
            gap={pxToRem(8)}
          >
            <IconV2>{getCategoryIcon(props.category || 'attraction')}</IconV2>
            <TextV2 typographyVariant={'hed1'}>{getCategoryTranslation(props.category || 'attraction')}</TextV2>
          </Flex>
          <Box
            marginBottom={pxToRem(16)}
            marginTop={pxToRem(8)}
          >
            <GuestSiteTypographyOverride override={hed6ToSubHeadingOverride}>
              <TextV2
                as="h2"
                typographyVariant="hed6"
                fontWeight={'semibold'}
              >
                {props.title}
              </TextV2>
            </GuestSiteTypographyOverride>
          </Box>
          <Box>
            <GuestSiteTypographyOverride override={label2ToParagraphOverride}>
              <TextV2
                typographyVariant="label2"
                marginTop={pxToRem(4)}
              >
                {props.description}
              </TextV2>
            </GuestSiteTypographyOverride>
          </Box>
        </Box>
        {FooterContent && FooterContent}
        {!FooterContent && !isGetYourGuideDomain(props.url) && (
          <Box paddingTop={pxToRem(10)}>
            <TextV2
              typographyVariant="body1"
              truncate
            >
              {getDomainFromUrl(props.url)}
            </TextV2>
          </Box>
        )}
      </Flex>
    </CustomContainerWrapper>
  );
};
